"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var reactstrap_1 = require("reactstrap");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ButtonWithModal_1 = __importDefault(require("atomicComponents/organisms/Button/ButtonWithModal"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var logging_1 = require("utils/logging");
var single_1 = require("utils/selectors/single");
// ToDo: remove /Companies and move all this logic to /CustomerManagement
var hooks_2 = require("../../../ConfirmationModal/hooks");
var GetLineItemsModal_1 = __importDefault(require("../../Common/GetLineItemsModal"));
var InviteModal_1 = __importDefault(require("../InviteModal"));
var AssignAccountantModal_1 = __importDefault(require("./AssignAccountantModal"));
var CreateXeroAppsPopover_1 = __importDefault(require("./CreateXeroAppsPopover"));
var DownloadPopover_1 = __importDefault(require("./DownloadPopover"));
var FlagsPopover_1 = __importDefault(require("./FlagsPopover"));
var monthlyEmail_1 = require("./monthlyEmail");
var ResyncModal_1 = __importDefault(require("./ResyncModal"));
var UploadPopover_1 = __importDefault(require("./UploadPopover"));
var CompanyActions = function (_a) {
    var _b, _c, _d;
    var company = _a.company;
    var _e = __read((0, react_1.useState)(false), 2), nominateModalOpen = _e[0], setNominateModalOpen = _e[1];
    var _f = __read(react_1.default.useState(false), 2), resyncModalOpen = _f[0], setResyncModalOpen = _f[1];
    var profileWithId = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _g = __read((0, hooks_1.useSubmitter)('companies', company.id, undefined, 500), 2), updateCompany = _g[0], isUpdatingCompany = _g[1];
    var _h = __read((0, hooks_1.useSubmitter)('recharger_companies', company.id, undefined), 2), updateRecharger = _h[0], isUpdatingRecharger = _h[1];
    var prompt = (0, hooks_2.useConfirm)();
    var _j = __read((0, backend_1.useCall)('transactions-fetchAttachmentsCall', { companyId: company.id }), 2), callFetchAttachments = _j[0], isCallingFetchAttachments = _j[1];
    var _k = __read((0, backend_1.useCall)('invoicing-finishfaileddeliveries', { companyId: company.id }), 2), finishFailedDeliveries = _k[0], isFinishingFailedDeliveries = _k[1];
    var _l = __read((0, backend_1.useCall)('transactions-bookaccconnectionsforrechargedorgs', { companyId: company.id, provider: 'Xero' }), 2), bookAccConnectionsForOrgs = _l[0], isBookingAccConnectionsForOrgs = _l[1];
    var _m = __read(react_1.default.useState(null), 2), progressState = _m[0], setProgressState = _m[1];
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var impersonate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.firestore().collection('users').doc(profileWithId.id).set({ companyId: company.id }, { merge: true })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onClickCalc = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((0, end2end_1.calculateStartedRecently)(company)) {
                        (0, logging_1.logError)('Calculate might still be ongoing');
                        return [2 /*return*/];
                    }
                    if (!company.isMappingTransactions) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCompany({ isMappingTransactions: false })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4 /*yield*/, updateCompany({ isMappingTransactions: true })];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var promoteToRechargly = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, prompt('Are you absolutely sure?', '', 'red', 'Yes, I am!')];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all([
                            !company.isAccountingFirm && updateCompany({ isAccountingFirm: true }),
                            updateRecharger({ name: company.name, promotedBy: profileWithId.id }),
                        ])];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var lastSummaryEmailsSent = (_c = (_b = (0, lodash_1.last)(company.summaryEmailsSent)) === null || _b === void 0 ? void 0 : _b.toDate) === null || _c === void 0 ? void 0 : _c.call(_b);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ my: 6, width: 1000 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ mb: 1, level: 3 }, { children: "Company Actions" })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, flexWrap: "wrap", maxWidth: 850 }, { children: [(0, jsx_runtime_1.jsx)(ButtonWithModal_1.default, __assign({ modalComponent: GetLineItemsModal_1.default, modalProps: { company: company } }, { children: "Get Line Items" })), (0, jsx_runtime_1.jsxs)(Button_1.default, __assign({ onClick: impersonate }, { children: ["Switch into ", company.name] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return setNominateModalOpen(true); } }, { children: "Invite" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: onClickCalc, disabled: isUpdatingCompany || (0, end2end_1.calculateStartedRecently)(company) }, { children: company.isMappingTransactions || company.isAggregatingServiceStats ? 'Reset & Calculate' : 'Calculate' })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: callFetchAttachments(), isSending: isCallingFetchAttachments }, { children: "Fetch Attachments" })), (0, jsx_runtime_1.jsx)(FlagsPopover_1.default, { company: company })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, flexWrap: "wrap", maxWidth: 800 }, { children: [(0, jsx_runtime_1.jsx)(DownloadPopover_1.default, { company: company }), (0, jsx_runtime_1.jsx)(UploadPopover_1.default, { company: company }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "button", isSending: company.isResyncing, disabled: !company.hasRefreshToken, onClick: function () { return setResyncModalOpen(true); } }, { children: "Resync" })), (0, jsx_runtime_1.jsx)(ButtonWithModal_1.default, __assign({ modalComponent: AssignAccountantModal_1.default, modalProps: { company: company } }, { children: "Assign Accountant" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return (0, monthlyEmail_1.sendMonthlyEmail)(setProgressState, company); } }, { children: "Send Monthly Report Email" })), company.summaryEmailsSent && ((0, jsx_runtime_1.jsxs)("small", { children: ["(", (_d = company.summaryEmailsSent) === null || _d === void 0 ? void 0 : _d.length, " emails sent) Last: ", (0, end2end_1.getISODate)(lastSummaryEmailsSent)] }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, flexWrap: "wrap", maxWidth: 700 }, { children: !company.hasRecharglyAccess
                            ? (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: promoteToRechargly, isSending: isUpdatingRecharger || isUpdatingCompany }, { children: "Promote to Rechargly" }))
                            : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [profileWithId.isTechAdmin && (0, jsx_runtime_1.jsx)(CreateXeroAppsPopover_1.default, { company: company }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: finishFailedDeliveries(), isSending: isFinishingFailedDeliveries }, { children: "Finish Failed Deliveries" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: bookAccConnectionsForOrgs(), isSending: isBookingAccConnectionsForOrgs }, { children: "Book accounting connections" }))] })) }))] })), (0, jsx_runtime_1.jsx)(InviteModal_1.default, { open: nominateModalOpen, company: company, onClose: function () { return setNominateModalOpen(false); } }), resyncModalOpen && (0, jsx_runtime_1.jsx)(ResyncModal_1.default, { close: function () { return setResyncModalOpen(false); }, company: company }), progressState && ((0, jsx_runtime_1.jsx)(material_1.Snackbar, __assign({ open: true, autoHideDuration: 20000, onClose: function () { return setProgressState(null); } }, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Alert, __assign({ onClose: function () { return setProgressState(null); }, severity: progressState.status }, { children: progressState.message })) })))] }));
};
exports.default = CompanyActions;
